import React, { useEffect } from 'react';
import { Form } from 'react-final-form';

import { startedNavigatorStep } from 'analytics/navigator';
import { StepName } from 'analytics/navigator/constants';
import { InitialValues } from 'forms/types';

import validate from '../util/validate';
import BasicInfoFormComponent from './component';
import { BasicHealthInfoProps, BasicInfoFormValues } from './types';

const BasicInfoForm: React.FC<BasicHealthInfoProps> = ({
  activeUserUuid,
  initialValues,
  onSubmit,
}) => {
  useEffect(() => {
    startedNavigatorStep(StepName.BASIC_INFO, activeUserUuid);
  }, []);

  return (
    <>
      <Form<BasicInfoFormValues, InitialValues<BasicInfoFormValues>>
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        {(formProps) => <BasicInfoFormComponent {...formProps} />}
      </Form>
    </>
  );
};

export default BasicInfoForm;
